'use strict';
import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

import dateRulesHtmlUrl from '../../products/views/dateRules.html';
import newFieldHtmlUrl  from '../../../views/shared/addField.html';
import recalculateAllHtmlUrl from "../../products/views/recalculateAll.html";
import showRecalculateResultsHtmlUrl from "../../products/views/showRecalculateResults.html";

angular.module('formlist.ctrls', [])
    .controller('FormListController', FormListController)
    .controller('FormListGroupsController', FormListGroupsController)
    .controller('FormListLookupController', FormListLookupController)
    .controller('FormDateRuleController', FormDateRuleController);

FormListController.$inject = ['$scope', '$rootScope', '$state', 'FormService', 'TaskService', '$rootScope', 'ClusterService', 'DateRangeService', 'UserService', '$ioAlert','$modal', 'ModalService', 'DashboardsDataPublisherHelper'];

function FormListController($scope, $rootScope, $state, FormService, TaskService, $rs, ClusterService, DateRangeService, UserService, $ioAlert, $modal, ModalService, DashboardsDataPublisherHelper) {
    $scope.formsListAll = [];
    $scope.formsList = [];
    $scope.formListType = {};
    $scope.tasksList = [];
    $scope.contentTypesList = [
        {"id": "0", "name": "Show all"},
        {"id": "1", "name": "Task"},
        {"id": "2", "name": "Order"},
        {"id": "3", "name": "Client"}
    ];
    $scope.formListType = $scope.contentTypesList[0];
    $scope.disableBtnAction = false;
    $scope.showActiveForm = true;

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.formList = [];
        getOrderAndTaskList();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.formsListByContentType = function(){
        $scope.formsList = [];
        _.each($scope.formsListAll, function(formObj){
            if($scope.formListType.id == "0"){
                $scope.formsList.push(formObj);
            }else if($scope.formListType.id == "1" && formObj.contentTypeId == "1"){
                $scope.formsList.push(formObj);
            }else if($scope.formListType.id == "2" && formObj.contentTypeId == "2"){
                $scope.formsList.push(formObj);
            }else if($scope.formListType.id == "3" && formObj.contentTypeId == "3"){
                $scope.formsList.push(formObj);
            }
        });
    };

    var getOrderAndTaskList = function(){
        $rootScope.loadingInProgress = true;
        $rootScope.loadertitle = "Fetching Form List";
        $scope.formsListAll = [];
        TaskService.getTasksList(ClusterService.clusterIds[0]).then(function(success) {
            $scope.tasksList = TaskService.tasksList;
            FormService.getOrderAndTaskList(ClusterService.clusterIds[0], !$scope.showActiveForm).then(function(formData) {
                _.each(formData, function(formObj){
                    const clusterNames = computeBusinessUnitDisplayField(formObj.cluster_ids);
                    const taskNames = computeTaskNamesDisplayField(formObj.task_names);
                    let typeString;
                    switch (formObj.content_type_id) {
                        case '1':
                            typeString = "task";
                            break;
                        case '2':
                            typeString = "order";
                            break;
                        case '3':
                            typeString = "client";
                            break;
                    }
                    $scope.formsListAll.push({
                        "id": formObj.id,
                        "contentTypeId": formObj.content_type_id,
                        "name": formObj.name,
                        "taskIds": formObj.task_ids,
                        "taskNames": taskNames,
                        "task_names": formObj.task_names,
                        "clusterIds": formObj.cluster_ids,
                        "clusterNames": clusterNames,
                        "isDefault": formObj.is_default == "1",
                        "type": typeString,
                        "active": ((formObj.content_type_id == "2" || formObj.content_type_id == "3") ?
                            ((formObj.cluster_ids != null && formObj.cluster_ids.length > 0) || formObj.is_default == "1") :
                            formObj.task_ids.length !== 0),
                        "__NEW_ORDERS_WORKFLOW_FORM_LINK__": formObj.__NEW_ORDERS_WORKFLOW_FORM_LINK__
                    });
                });
                $scope.formsListAll.sort($scope.compareFormElements);
                $scope.formsListByContentType();
                $rootScope.loadingInProgress = false;
            }, function(error){
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                $rootScope.loadingInProgress = false;
            });
        });
    }

    $scope.compareFormElements = function(a, b) {
        // Note that backend returns default order form first, so don't check for that here.
        if(b.isDefault === true){
            return 1;
        }else if (a.contentTypeId < b.contentTypeId) {
            return 1;
        } else if (a.contentTypeId > b.contentTypeId) {
            return -1;
        } else if (a.active < b.active) {
            return 1;
        } else if (a.active > b.active) {
            return -1;
        } else {
            return a.id - b.id;
        }
    };

    const computeBusinessUnitDisplayField = function(clusterIds) {
        if (!clusterIds) {
            return "(None)";
        }
        const numClusters = clusterIds.length;
        if (numClusters === 0) {
            return "(None)";
        }
        else if (numClusters === 1) {
            return _.find(ClusterService.clusters, { id: clusterIds[0] }).name;
        }
        else if (numClusters === 2) {
            return _.find(ClusterService.clusters, { id: clusterIds[0] }).name + ', ' + _.find(ClusterService.clusters, { id: clusterIds[1] }).name;
        }
        else {
            if (clusterIds.includes(ClusterService.clusterIds[0])) {
                return _.find(ClusterService.clusters, { id: ClusterService.clusterIds[0] }).name + ' and ' + (numClusters - 1) + ' others';
            } else {
                return '(' + numClusters + ' business units)';
            }
        }
    };

    const computeTaskNamesDisplayField = function(taskNames) {
        if (!taskNames) {
            return "(None)";
        }
        const numTasks = taskNames.length;
        if (numTasks === 0) {
            return "(None)";
        }
        else if (numTasks === 1) {
            return taskNames[0];
        }
        else if (numTasks === 2) {
            return taskNames[0] + ', ' + taskNames[1];
        }
        else {
            return taskNames[0] + ' and ' + (numTasks - 1) + ' others';
        }
    };

    // Navigate to the form configure page, Ret
    $scope.viewGroups = function(form) {
        $state.go('formListGroups', {
            "formId": form.id,
            "contentTypeId": form.contentTypeId
        });
    };

    // Navigate to looks ups page
    $scope.viewLookups = function(form) {
        if (form.formId == 0) {
            $ioAlert.show('', 'You must select a business unit to continue.', 'error');
        } else {
            $state.go('formListLookup', {
                "formId": form.id,
                "contentTypeId": form.contentTypeId
            });
        }
    };

    //Show or hide line item for the instance
    $scope.toggleLineItemHide = function(status) {
        var obj = {
            "setting_type": "line_item_hidden",
            "value": status
        }
        if ($rs && $rs.lineItemHide && $rs.lineItemHide.id) {
            obj.id = $rs.lineItemHide.id;
            FormService.updateToggleLineItem(obj).then(function(data) {
                $ioAlert.show('', 'Updated Successfully', 'success');
                getInstanceSettings();
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else {
            FormService.saveToggleLineItem(obj).then(function(data) {
                $ioAlert.show('', 'Updated Successfully', 'success');
                getInstanceSettings();
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

    };

    $scope.filterFormActive = function() {
        $scope.showActiveForm = !$scope.showActiveForm;
        getOrderAndTaskList();
    };

    // Get Instance setting only once and set it to rootScope value
    function getInstanceSettings() {
        FormService.getInstanceSettings("line_item_hidden").then(function(data) {
            if (data && data.id) {
                $rs.lineItemHide = {
                    "setting_type": data.setting_type,
                    "id": data.id,
                    "value": data.value
                };
            } else {
                $rs.lineItemHide = {};
            }
            $scope.hideLineItem = ($rs.lineItemHide.value === '1');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $scope.showLineItem = true;
            $scope.showCreatives = false;
        });
    }

    $scope.editOrderAndTask = function(list) {
        if (list) {
            $scope.addOrderAndTask(list)
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.addOrderAndTask = function(list) {
        let isNew = true;
        if (list) {
            isNew = false;
        }
        let modalObj = $modal.open(
            ModalService.returnModalType('createNewForm', {
                data: {
                    list: list,
                    clusters: ClusterService.clusters.slice(1),  // Shallow copy, skipping item 0 (All Business Units)
                    formListType: $scope.contentTypesList,
                    tasksList: $scope.tasksList
                }
            })
        );
        modalObj.result.then(function(formObj) {
            $scope.loadingInProgress = true;
            if (isNew) {
                FormService.saveOrderAndTaskForm(formObj).then(function(data) {
                    if (data && data.needs_force_update) {
                        let modalForceObj = $modal.open(
                            ModalService.returnModalType('forceAddOrUpdateForm', {
                                data: {
                                    errors: data.errors,
                                }
                            })
                        );
                        modalForceObj.result.then(function() {
                            formObj.forceUpdate = true; // This will modify cascaded target field configuration
                            FormService.saveOrderAndTaskForm(formObj).then(function(data) {
                                if (data && data.errors) {
                                    $ioAlert.show('', data.errors[0], 'error');
                                    $scope.loadingInProgress = false;
                                } else {
                                    $ioAlert.show('', 'New Form has been created successfully and affected products updated', 'success');
                                    getOrderAndTaskList();
                                }
                            }, function(error) {
                                console.log("Error adding product");
                                $scope.loadingInProgress = false;
                            });
                        }, function(cancel) {
                                $scope.loadingInProgress = false;
                            }
                        );
                    } else if (data && data.errors) {
                        $ioAlert.show('', data.errors[0], 'error');
                        $scope.loadingInProgress = false;
                    } else {
                        $ioAlert.show('', 'New Form has been created successfully', 'success');
                        getOrderAndTaskList();
                    }
                }, function(error) {
                    console.log("Error adding product");
                    $scope.loadingInProgress = false;
                });
            } else {
                FormService.updateOrderAndTaskForm(formObj).then(function (data) {
                    if (data?.needs_force_update) {
                        let modalForceObj = $modal.open(
                            ModalService.returnModalType('forceAddOrUpdateForm', {
                                data: {
                                    errors: data.errors,
                                }
                            })
                        );
                        modalForceObj.result.then(function() {
                                formObj.forceUpdate = true; // This will modify cascaded target field configuration
                                FormService.updateOrderAndTaskForm(formObj).then(function(data) {
                                    if (data && data.errors) {
                                        $ioAlert.show('', data.errors[0], 'error');
                                        $scope.loadingInProgress = false;
                                    } else {
                                        $ioAlert.show('', 'New Form has been updated successfully and affected products updated', 'success');
                                        getOrderAndTaskList();
                                    }
                                }, function(error) {
                                    console.log("Error adding product");
                                    $scope.loadingInProgress = false;
                                });
                            }, function(cancel) {
                                $scope.loadingInProgress = false;
                            }
                        );
                    } else if (data?.errors) {
                        $ioAlert.show('', data.errors[0], 'error');
                        $scope.loadingInProgress = false;
                    } else {
                        $ioAlert.show('', 'Form has been updated successfully', 'success');
                        getOrderAndTaskList();
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    $scope.loadingInProgress = false;
                });
            }
        }, function(cancel) {

        });
    };

    $scope.cloneAllFormLookupContent = function() {
        if (!ClusterService.clusterIds.length || ClusterService.clusterIds[0] == 0) {
            $ioAlert.show('', 'You must select a business unit to continue.', 'error');
        } else {
            const modalObj = $modal.open(
                ModalService.returnModalType('lookupContentForClusterClone', {
                    data: {
                        clusters: ClusterService.clusters
                    }
                })
            );
            modalObj.result.then(function(formObj) {
                FormService.cloneAllFormLookupContentForClusters(formObj.sourceClusterId, formObj.destClusterIds).then(function(data) {
                    if (data.errors) {
                        $ioAlert.show('', data.errors[0], 'error');
                    } else if (data.dest_cluster_ids) {
                        $ioAlert.show('', 'Lookup content cloned successfully', 'success');
                    } else {
                        $ioAlert.show('', 'An error occurred cloning lookup content.', 'error');
                    }
                }, function(error) {
                    $ioAlert.show('', 'An error occurred cloning lookup content.', 'error');
                });
            }, function(cancel) {});
        }
    };

    // Helper function to publish to dashboards
    $scope.publishToDashboards = function() {
        DashboardsDataPublisherHelper.publishData()
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    // Helper function to import a form
    $scope.importForm = function() {
        if ($scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            $ioAlert.show('', 'File is being uploaded, please do not refresh the page', 'success');
            FormService.importForm($scope.uploadMedia.file).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                    console.log(response.errors);
                } else {
                    $ioAlert.show('', 'File Imported successfully', 'success');
                    getOrderAndTaskList();
                }
            }, function(errors) {
                for (let i = 0, len = errors.length; i < len; i++) {
                    $ioAlert.show('ERROR!', errors[i], 'error');
                }
                console.log("Error importing form: " + errors);
            });
        }
    };

    // Helper function to export a form
    $scope.exportForm = function(formId) {
        FormService.exportForm(formId).then(function(response) {
            let errors = response.data.errors;
            if (errors) {
                $ioAlert.show('', 'An error occurred exporting form: ' + errors[0], 'error');
                console.log(errors);
            } else {
                let csvString = response.data;
                let a = $('<a/>', {
                    style: 'display:none',
                    href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                    download: 'form_' + formId + '.csv'
                }).appendTo('body');
                a[0].click();
                a.remove();
                $ioAlert.show('', 'File exported successfully', 'success');
            }
        }, function(error) {
            $ioAlert.show('', 'An error occurred exporting form.', 'error');
            console.log(error);
        });
    };
    UserService.adjustStickyHeaderWindowResize();

    // Initialization function to handle the cluster selector
    var init = function() {
        ClusterService.initCluster($rs.userRole);
        DateRangeService.init();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
        if ($rs.lineItemHide) {
            if ($rs.lineItemHide.id) {
                $scope.hideLineItem = ($rs.lineItemHide.value === '1');
            }
        } else {
            getInstanceSettings();
        }
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

FormListGroupsController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', '$confirm', 'FormService', 'ProductService', 'ClusterService', 'DateRangeService', 'UserService', '$modal', '$ioAlert', 'ModalService', 'OrdersService', '$filter', '$anchorScroll','anchorSmoothScroll', '$location', '$timeout', 'WorkflowsService'];

function FormListGroupsController($scope, $rs, $stateParams, $state, $confirm, FormService, ProductService, ClusterService, DateRangeService, UserService, $modal, $ioAlert, ModalService, OrdersService, $filter, $anchorScroll,anchorSmoothScroll, $location, $timeout, WorkflowsService) {
    const FIELD_MAX_LENGTH = 44;

    let formId = $stateParams.formId;
    $scope.contentTypeId = $stateParams.contentTypeId;
    $scope.groupsList = [];
    $scope.groupNames = [];  // For use by add/edit field modal
    $scope.displayGroupsList = [];
    $scope.fieldsList = [];
    $scope.activeFieldsList = [];
    $scope.formFieldsObj = [];
    $scope.formFilterObj = [];
    $scope.lookUpTypes = [];
    $scope.dataTypes = [];
    $scope.inputTypes = [];
    $scope.rollupTargetFieldNames = [];
    $scope.workflowActions = [];
    $scope.showActiveFormListGroup = true;
    $scope.sortableIconShowHide = true;
    $scope.showSynchronized = false;
    $scope.sortableDragIconShowHide = [];
    $scope.showForm = false;
    $scope.isDisabled = false;
    $scope.defaultValueDisabled = true;
    $scope.defaultValueType = 'text';
    $scope.defaultInputType = 'text';
    $scope.defaultValuePrevType = '';
    $scope.defaultLookupContents = [];
    $scope.disableDisplayOrder = false;
    $scope.selectedRow = null;
    $scope.fieldHeaderName="Add Field";
    $scope.hideEditFieldGroupName = [];
    $scope.modalShown = false;
    $scope.toggleModal = function() {
        $scope.modalShown = !$scope.modalShown;
    };
    $scope.showActive = true;
    $scope.oldvalue = {};
    var highlightedField = {};
    $scope.disableBtnAction = false;
    $scope.showLookupType = true;
    $scope.fieldsTableData = [
        {
            name: "Id",
            value: "id",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Field Name",
            value: "field_name",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Display Name",
            value: "display_name",
            id: true,
            isClientEnabled: true
        },

        {
            name: "Data Type",
            value: "data_type",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Input Type",
            value: "input_type_name",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Cascading Field Name",
            value: "cascading_field_name",
            id: true,
            isClientEnabled: false
        },
        {
            name: "Parent",
            value: "parent_id",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Parent Trigger",
            value: "parent_trigger_id",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Lookup Type Id",
            value: "lookup_type_id",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Default Value",
            value: "default_value",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Required",
            value: "required",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Show Long Text",
            value: "show_long_text",
            id: false,
            isClientEnabled: false
        },
        {
            name: "Type Ahead",
            value: "enable_type_ahead",
            id: false,
            isClientEnabled: false
        },
        {
            name: "Show in Dashboards",
            value: "dashboard_enabled",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Grid Show",
            value: "grid_show",
            id: false,
            isClientEnabled: false
        },
        {
            name: "Active",
            value: "active",
            id: false,
            isClientEnabled: true
        },
        {
            name: "Help Text",
            value: "help_text",
            id: true,
            isClientEnabled: true
        },
        {
            name: "Formula",
            value: "formula",
            id: true,
            isClientEnabled: false
        },
        {
            name: "Validation Rules",
            value: "validation_rules",
            id: true,
            isClientEnabled: false
        },
        {
            name: "Goal Association",
            value: "goal_association",
            id: true,
            isClientEnabled: false
        },
        {
            name: "Rollup Field Name",
            value: "rollup_field_name",
            id: true,
            isClientEnabled: false
        },
        {
            name: "Custom Edit Action",
            value: "custom_edit_action_name",
            id: false,
            isClientEnabled: true
        }
    ];
    $scope.fieldsHeader = {};
    $scope.trsortableOptions = {};
    $scope.fieldTemplate = newFieldHtmlUrl;
    $scope.showParentMultiSelect = true;
    $scope.editableEnum = [
        {"label": "Editable", "value": 'enable'},
        {"label": "Add Only", "value": 'add'},
        {"label": "Edit Only", "value": 'edit'},
        {"label": "Not Editable", "value": 'disable'}
    ];
    $scope.defaultDateOptions = [
        "Today",
        "Tomorrow",
        "Yesterday",
        "Next week",
        "Next month",
    ];
    $scope.dateOffset = 0;
    $scope.willExpandAllGroups = true;
    $scope.isExpandCollapseButtonDisabled = true;

    $scope.resetParentId = function() {
        $scope.fieldsObj.parentId = undefined;
        $scope.showParentMultiSelect = true;
    }

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        if (formId) {
            getFormFieldGroups();
            getFormFields();
            getHideConditionTypes();
        } else {
            $scope.backToList();
        }
    });

    $scope.enableEditFieldGroupName = function (groupId) {
        $scope.hideEditFieldGroupName[groupId] = true;
    }
    $scope.cancelEditFormListGroupName = function(groupId) {
        $scope.hideEditFieldGroupName[groupId] = false;
    }

    $scope.disableEditFieldGroupName = function (groupId, groupObj) {
        if(groupObj.group_name.length === 0){
            $ioAlert.show('Error', 'Group Name Can not be empty.', 'error');

            $scope.hideEditFieldGroupName[groupId] = true;
        } else if(groupObj.group_name.includes('Buy')) {
            $ioAlert.show('Error', 'Form Group name cannot include \'Buy\'', 'error');
            $scope.hideEditFieldGroupName[groupId] = true;
        } else {
            if($scope.oldvalue[groupObj.id] !== groupObj.group_name){
                $scope.hideEditFieldGroupName[groupId] = false;
                var param = {};
                param.groupName = groupObj.group_name;
                param.groupDisplayOrder = groupObj.group_display_order;
                param.hideForCondition = groupObj.hide_for_condition;
                param.active = groupObj.active;
                param.id = groupObj.id;
                param.formId = groupObj.form_id;
                $scope.oldvalue[groupObj.id] = groupObj.group_name;
                FormService.updateFormFieldGroups(param).then(function (data) {
                    $ioAlert.show('Success', ' Group updated successfully', 'success');
                }, function (error) {
                    $ioAlert.show('Error', 'Error updating Group', 'error');
                });
            }
        }
    }


  //handle Form List  Group  Active and Inactive
  $scope.formListGroupActiveChange = function(groupObj,$event) {
    $event.preventDefault();
    $event.stopPropagation();
    if (groupObj) {
        let text = '';
        if (groupObj.active === true) {
            text = 'Are you sure you want to disable this Form List group?';
        } else {
            text = 'Are you sure you want to enable this Form List group?';
        }
        $confirm.open({
            size: 'sm',
            text: text
        }).then(function() {
            groupObj.active = (groupObj.active == true) ? false : true;
            updateFormListGroup(groupObj);
        }, function() {
            console.log("cancel")
        });
    }
}

    const updateDisplayGroupsList = function() {
        $scope.displayGroupsList = [];
        _.each($scope.groupsList, function (groupObj) {
            (groupObj.active == true) ? $scope.displayGroupsList.push(groupObj) : '';
        });
        $scope.displayGroupsList = $scope.showActiveFormListGroup == true ? $scope.displayGroupsList : $scope.groupsList;
        $scope.groupNames = $scope.groupsList;
    }

    const updateFormListGroup = function (groupObj) {
        let param = {};
        param.groupName = groupObj.group_name;
        param.groupDisplayOrder = groupObj.group_display_order;
        param.id = groupObj.id;
        param.formId = groupObj.form_id;
        param.active = (groupObj.active === true || groupObj.active == '1') ? '1' : '0';
        param.hideForCondition = groupObj.hide_for_condition;
        FormService.updateFormFieldGroups(param).then(function(data) {
            if (data.errors) {
                groupObj.active = (groupObj.active == true) ? false : true;
                $ioAlert.show('', data.errors[0], 'error');
            } else {
                if (data.formFieldGroup && data.formFieldGroup.id) {
                    data.formFieldGroup.active = data.formFieldGroup.active == '1';
                    for (let i = 0, len = $scope.groupsList.length; i < len; i++) {
                        if ($scope.groupsList[i].id == data.formFieldGroup.id) {
                            $scope.groupsList[i] = data.formFieldGroup;
                            break;
                        }
                    }
                   updateDisplayGroupsList();
                   $ioAlert.show('', 'Updated Successfully', 'success');
                }
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.iosortableOptions = {
        handle: '.handle',
        stop: function(e, ui) {
            for (var group in $scope.displayGroupsList) {
                $scope.displayGroupsList[group].group_display_order = Number(group) + 1;
            }
            _.each($scope.displayGroupsList, function(groupObj, index) {
                if (groupObj.active == true) {
                    var param = {};
                    param.groupName = groupObj.group_name;
                    param.groupDisplayOrder = groupObj.group_display_order;
                    param.active = groupObj.active;
                    param.formId = groupObj.form_id;
                    param.id = groupObj.id;
                    param.clusterId = ClusterService.clusterIds[0];
                    param.hideForCondition = groupObj.hide_for_condition;
                    FormService.updateFormFieldGroups(param).then(function(data) {
                        if (index + 1 == $scope.displayGroupsList.length) {
                            $ioAlert.show('Success', 'Display Order updated successfully', 'success');
                        }
                    }, function(error) {
                        $ioAlert.show('Error', 'Error updating Display Order', 'error');
                    });
                }
            });

        }
    }
    //For not shrinking the table width when drag and drop
    var fixHelper = function (e, ui) {
        ui.children().each(function () {
            $(this).width($(this).width());
        });
        return ui;
    };


    $scope.filterFormListGroupsActiveColumn = function() {
        $scope.showActiveFormListGroup = !$scope.showActiveFormListGroup;
        $scope.sortableIconShowHide = $scope.showActiveFormListGroup;
        updateDisplayGroupsList();
    };

    var getFormFieldGroups = function() {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Group Details";
        FormService.getFormFieldGroups(formId, ClusterService.clusterIds[0], 1).then(function(data) {
            $scope.groupsList = data;
            $scope.displayGroupsList = [];
            _.each($scope.groupsList, function (groupObj) {
                $scope.oldvalue[groupObj.id] = groupObj.group_name;
                groupObj.active = (groupObj.active == "1")?true:false;
                (groupObj.active == true) ? $scope.displayGroupsList.push(groupObj) : '';
            });
            $scope.displayGroupsList = $scope.showActiveFormListGroup == true ? $scope.displayGroupsList : $scope.groupsList;
            $scope.groupNames = $scope.groupsList;
            getOrderTypes();
            $scope.isExpandCollapseButtonDisabled = data.length === 0;
            $rs.loadingInProgress = false;
        }, function() {
            console.log("error loading form fields list");
            $rs.loadingInProgress = false;
        });
    };

    var getOrderTypes = function() {
        OrdersService.getOrderTypes().then(function(orderTypes) {
            $scope.orderTypes = orderTypes;
            parseHideCondition();
        }, function(error) {
            console.log("error loading order types types");
        });
    }

    var getRoleTypes = function() {
        UserService.getRoleTypes().then(function(types) {
            $scope.roleTypes = types;
        }, function(error) {
            console.log("error loading role types");
        });
    };

    var getHideConditionTypes = function () {
        $scope.hideConditionTypes = [];
        $scope.hideConditionTypes.push('Order Type');
        $scope.hideConditionTypes.push('Role Type');
        getOrderTypes();
        getRoleTypes();
    };

    var getFormFields = function() {
        //get form fields and show all
        FormService.getFormFields(formId, ClusterService.clusterIds[0], 1).then(function(data) {
            $scope.fieldsList = data;
            formFieldsHelper();
            $scope.activeFieldsList = $scope.fieldsList.filter(field => field.active == 1);
            $scope.activeFieldsList = _.orderBy($scope.fieldsList, (item) => item.field_name.toLowerCase());

            var otherDates = $scope.activeFieldsList.filter(field => field.data_type == "date")
                .map(field => (field.field_name));
            $scope.defaultDateOptions.push.apply($scope.defaultDateOptions, otherDates);
        }, function() {
            console.log("error loading form fields list");
        });
    };

    var getDataTypes = function() {
        FormService.getDataTypes($scope.contentTypeId).then(function(data) {
            $scope.dataTypes = data.sort();
        }, function(error) {
            console.log("error loading data types");
        })
    };

    var getGoalAssociationTypes = function() {
        FormService.getGoalAssociationTypes().then(function(data) {
            $scope.goalAssociationsTypes = _.orderBy(JSON.parse(data.goalFields), 'displayName');
        }, function(error) {
            console.log("error loading data types");
        })
    }

    function getRollupFieldNames() {
        switch ($scope.contentTypeId) {
            case '1':
                // Task.  Rollup target depends on the kind of task (order task, etc).  We pass the task formId to the
                // backend, who will determine the appropriate rollup targets. Here, we do not know which kind of task
                // we have!
                FormService.getTaskRollupTargets(formId).then(function(fieldNames) {
                    $scope.rollupTargetFieldNames = fieldNames;
                }, function(error) {
                    console.log("Error loading task rollup targets: " + error);
                });
                break;
            case '2':
                // For orders, the rollup targets are at the client level
                FormService.getClientRollupTargets().then(function(fieldNames) {
                    $scope.rollupTargetFieldNames = fieldNames;
                }, function(error) {
                    console.log("Error loading client rollup targets: " + error);
                });
                break;
            case '3':
                // No rollup targets for clients
                break;
        }
    }

    function getWorkflowActions() {
        WorkflowsService.getWorkflowActions(true).then(function(data) {
            $scope.workflowActions = _.orderBy(data, 'name');
        }, function() {
            console.log("Error fetching workflow actions.");
        });
    }

    var getInputTypes = function() {
        FormService.getInputTypes($scope.contentTypeId).then(function(data) {
            $scope.inputTypesList = data;
            var inputTypes = [];
            $scope.inputTypes = [];
            _.each(data, function(label, key){
                inputTypes.push({key: key, label: label});
            });
            inputTypes = _.sortBy(inputTypes, 'label');
            _.each(inputTypes, function(inputType){
                if(isNaN(inputType.label.charAt(0))){
                    $scope.inputTypes.push(inputType);
                }
            });
            _.each(inputTypes, function(inputType){
                if(!isNaN(inputType.label.charAt(0))){
                    $scope.inputTypes.push(inputType);
                }
            });
        }, function(error) {
            console.log("error loading input types");
        })
    };

    var getLookupTypes = function() {
        ProductService.getLookupTypes().then(function(success) {
            $scope.lookUpTypes = _.orderBy(ProductService.lookupTypes, 'name');
        }, function(error) {
            console.log("error loading lookup types");
        });
    };

    var parseHideCondition = function () {
        _.each($scope.groupsList, function (list) {
            if (list.hide_for_condition) {
                const typeId = JSON.parse(list.hide_for_condition).id;
                const conditionType = JSON.parse(list.hide_for_condition).type;
                list.conditionType = conditionType;
                list.selectedHideCondition = [];
                if ("Order Type" == conditionType) {
                    _.find($scope.orderTypes, function (o) {
                        const groupItem = typeId?.split(',');
                        if (groupItem?.contains(o.id.toString())) {
                            list.selectedHideCondition.push(o);
                        }
                    });
                }
                if ("Role Type" == conditionType) {
                    _.find($scope.roleTypes, function (o) {
                        const groupItem = typeId?.split(',');
                        if (groupItem?.contains(o.id.toString())) {
                            list.selectedHideCondition.push(o);
                        }
                    });
                }
            }
        });
    }

    var filterGroupFormListFields = function(groupId){
        _.each($scope.fieldsList, function(formListField){
            formListField.display_order = parseInt(formListField.display_order);
        });
        $scope.fieldsList = _.orderBy($scope.fieldsList, 'display_order');
        $scope.formFieldsObj[groupId] = [];
        _.each($scope.fieldsList, function(formListField){
            if (groupId == formListField.group_id && formListField.active == '1') {
                $scope.formFieldsObj[groupId].push(formListField);
            }
        });
    }

    $scope.recalculateAll = function() {
        // We really would need the form, but a form field does the job too, and that's what the backend already
        // does.  If we get here, we have at least one calculateFields, so use the first one, it's as good as any.
        FormService.orderIdsUsingFormField($scope.calculateFields[0].id).then(function(data) {
            if (data && data.id_list) {
                if (data.id_list.length == 0) {
                    $ioAlert.show('Error', 'There are no orders using this form', 'error');
                } else {
                    recalculateAllExec(data.id_list);
                }
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Could not fetch the list of order ids using this form', 'error');
        });
    }

    let recalculateAllExec = function(idList) {
        $modal.open({
            controller: 'RecalculateAllController',
            templateUrl: recalculateAllHtmlUrl,
            resolve: {
                calculateFields: function() {
                    return $scope.calculateFields
                },
                targetEntity: function() {
                    return 'order'
                },
                idList: function() {
                    return idList
                }
            },
            backdrop: 'static'
        }).result.then(function(recalculateAllObj) {
            FormService.recalculateAllOrders(recalculateAllObj.fieldId).then(function(data) {
                if (data) {
                    showRecalculateResults(data);
                } else {
                    $ioAlert.show('Error', 'Error recalculating order attributes', 'error');
                }
            }, function(error) {
                console.log("Error recalculating attributes");
                $ioAlert.show('Error', 'Error recalculating order attributes', 'error');
            });
        }, function(cancel) {
        });
    }

    let showRecalculateResults = function(results) {
        $modal.open({
            controller: 'ShowRecalculateResultsController',
            templateUrl: showRecalculateResultsHtmlUrl,
            resolve: {
                results: function() {
                    return results
                },
                targetEntity: function() {
                    return 'order'
                }
            },
            backdrop: 'static'
        }).result.then(function(ok) {
        }, function(cancel) {
        });
    }

    let formFieldsHelper = function() {
        $scope.calculateFields = [];
        $scope.hasCalculateFields = false;
        $scope.hasFormulaErrors = false;
        $scope.formulaData = [];
        if ($scope.inputTypesList) {
            _.each ($scope.fieldsList, function(fieldObj) {
                if ($scope.inputTypesList[fieldObj.input_type]) {
                    fieldObj.input_type_name = $scope.inputTypesList[fieldObj.input_type];
                } else {
                    fieldObj.input_type_name = fieldObj.input_type;
                }
                if ((fieldObj.input_type == 'calculated' || fieldObj.input_type == 'calculated-override') &&
                    fieldObj.formula && fieldObj.active == '1') {
                    $scope.calculateFields.push(fieldObj);
                    $scope.hasCalculateFields = true;
                    if (fieldObj.__FORMULA_ERROR__) {
                        $scope.hasFormulaErrors = true;
                    }
                    const formulaObj = {
                        id: fieldObj.id,
                        name: fieldObj.field_name,
                        formula: fieldObj.formula,
                        error: fieldObj.__FORMULA_ERROR__ ? fieldObj.__FORMULA_ERROR__ : ''
                    };
                    $scope.formulaData.push(formulaObj);
                }
                if (fieldObj.custom_edit_action_id && fieldObj.custom_edit_action_id > 0) {
                    const wfAction = _.find($scope.workflowActions, {id: fieldObj.custom_edit_action_id});
                    if (wfAction) {
                        fieldObj.custom_edit_action_name = wfAction.name;
                    } else {
                        fieldObj.custom_edit_action_name = '(not found)';
                    }
                }
                if (!$scope.showSynchronized && (fieldObj.__new_ui_order_form_field_id || fieldObj.__new_ui_task_form_field_id || fieldObj.__new_ui_client_form_field_id)) {
                    $scope.showSynchronized = true;
                }
            });
        }
    }

    $scope.showFormulaErrors = function() {
        $modal.open(
            ModalService.returnModalType('showFormulaErrors', {
                data: {
                    formulaErrors: $scope.formulaData
                }
            })
        );
    }

    $scope.toggleInformationBeingDisplayed = function() {
        $scope.isExpandCollapseButtonDisabled = true;
        let isExpandingAllGroups = $scope.willExpandAllGroups;
        $scope.willExpandAllGroups = !$scope.willExpandAllGroups;
        $timeout(function () {
            if (isExpandingAllGroups) {
                $('span[data-toggle-display="expand"]').click();
            } else {
                $('span[data-toggle-display="collapse"]').click();
            }
        }, 0);
        $timeout(function () {
            $scope.isExpandCollapseButtonDisabled = false;
        }, 900);
    }

    $scope.toggle = function(ev, group) {
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).parent().parent().siblings().children().last().show(900);
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            $(ev.target).attr('data-toggle-display', 'collapse');
            afterExpandingGroup();
            $scope.formFieldsObj[group.id] = [];
            $scope.formFilterObj[group.id] = "1";
            $scope.sortableDragIconShowHide[group.id] = "1";
            formFieldsHelper();
            filterGroupFormListFields(group.id);
            if ($scope.contentTypeId == 3) {
                // For client forms, only a subset of the columns are enabled since the front-end for client custom
                // fields does not support all schema form types and features.
                $scope.fieldsHeader[group.id] = [];
                _.each($scope.fieldsTableData, function (data) {
                    if (data.isClientEnabled) {
                        $scope.fieldsHeader[group.id].push(data);
                    }
                });
            } else {
                $scope.fieldsHeader[group.id] = angular.copy($scope.fieldsTableData);
                // Remove Cascading Field Name and Custom Edit Action from tasks since these fields do not apply to tasks
                if ($scope.contentTypeId == 1) {
                    const cascading_field_name_index = $scope.fieldsHeader[group.id].findIndex(item => (item.value === "cascading_field_name"));
                    $scope.fieldsHeader[group.id].splice(cascading_field_name_index, 1);
                    const custom_edit_action_index = $scope.fieldsHeader[group.id].findIndex(item => (item.value === "custom_edit_action_name"));
                    $scope.fieldsHeader[group.id].splice(custom_edit_action_index, 1);
                }
            }

            $scope.trsortableOptions[group.id] = {
                handle: '.handle',
                axis: "y",
                containment: ".product-content-" + group.id,
                helper: fixHelper,
                stop: function(e,ui) {
                    var groupId = $(ui.item).attr('group-id');
                    var fields = [];
                    var displayOrderCnt = 1;
                    _.each($scope.formFieldsObj[groupId],function(element,index){
                        element.originalDisplayOrder = element.display_order;
                        element.display_order = displayOrderCnt++;
                        if ((element.originalDisplayOrder !== element.display_order)) {
                            fields.push({
                                id: element.id,
                                displayOrder: element.display_order
                            });
                        }
                    });
                    if(fields.length > 0){
                        FormService.updateFormListDisplayOrder(fields).then(function(fieldsData) {
                            if(fieldsData){
                                _.each(fieldsData, function(fieldObj){
                                    var groupField = _.find($scope.formFieldsObj[groupId], {id: fieldObj.id});
                                    if(groupField){
                                        groupField.display_order = fieldObj.display_order;
                                    }
                                    var formListField = _.find($scope.fieldsList, {id: fieldObj.id});
                                    if(formListField){
                                        formListField.display_order = fieldObj.display_order;
                                    }
                                });
                                filterGroupFormListFields(groupId);
                                $ioAlert.show('', 'Formlist fields display order updated successfully', 'success');
                            }
                        }, function(error) {
                            console.log("error updating display order");
                            $scope.productLoader = false;
                        });
                    }

                }
            }
        } else {
            $(ev.target).parent().parent().siblings().children().last().hide(800);
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
            $(ev.target).attr('data-toggle-display', 'expand');
            afterCollapsingGroup();
        }
    };

    function afterExpandingGroup() {
        let count = $('span[data-toggle-display="expand"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = false;
        }
    }

    function afterCollapsingGroup() {
        let count = $('span[data-toggle-display="collapse"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = true;
        }
    }

    $scope.selectAll = function(groupId) {
        for (var i = 0, len = $scope.fieldsHeader[groupId].length; i < len; i++) {
          $scope.fieldsHeader[groupId][i].id = true;
        }
    };

    $scope.backToList = function() {
        $state.go('formList');
    };

    $scope.filterActiveColumn = function(groupId) {
        $scope.showActive = ! $scope.showActive;
        if ($scope.showActive) {
            $scope.formFilterObj[groupId] = "1";
            $scope.sortableDragIconShowHide[groupId] = "1";
        } else {
            $scope.formFilterObj[groupId] = "";
            $scope.sortableDragIconShowHide[groupId] = "";
        }
    };

    function addFieldModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    // initialize our variable to null
    $scope.addFormListFieldHeighlight = function (groupId, feildindex, field) {  //function that sets the value of selectedRow to current index
        _.each($scope.groupsList, function (element) {
            if (element.id == groupId) {
                _.each($scope.formFieldsObj[element.id], function (fieldObj) {
                    if (fieldObj.id == field.id) {
                        highlightedField = (highlightedField && fieldObj.id == field.id) ? {} : field;
                        $scope.selectedRow = ($scope.selectedRow == feildindex) ? null : feildindex;
                        $scope.grouprow = element.id;
                    }
                });
            }
        });
    }

    // Handle modal cancel
    $scope.hideFieldForm = function() {
        var myElement = angular.element( document.querySelector( '#fieldForm' ) );
        myElement.addClass('fieldFormInactive');
        $timeout(function () {
            $scope.modalShown = false;
        }, 1000);
    }

    /*
    *    Handle showing sliding box for add and edit form list field
    */
    $scope.showFormListFieldForm = function(group, field, is_copy = false) {
        $scope.modalShown = true;
        $scope.currentGroup = group;
        $scope.fieldsObj = {
            "groupId": $scope.currentGroup.id,
            "displayOrder":$scope.currentGroup.display_order,
            "isEditable": "enable"
        };
        $scope.groupName = $scope.currentGroup.group_name;
        $scope.fieldsList = angular.copy($scope.fieldsList);
        $scope.isNew = true;
        $scope.disableDisplayOrder = false;
        $scope.fieldHeaderName ="Add Field";
        $location.hash('field-body');
        anchorSmoothScroll.scrollTo('field-body');
        $timeout(function () {
            $location.hash('');
        }, 1000);
        if (field) {
            $scope.isNew = is_copy;
            if (!is_copy) {
                $scope.fieldHeaderName ="Update Field";
            } else {
                $scope.fieldHeaderName ="Copy Field #" + field.id + " As New Field";
            }
            $scope.groupName = $scope.currentGroup.group_name;
            $scope.disableDisplayOrder = true;
            formatObj(field, is_copy);
            if (field && field.parent_id) {
                $scope.checkLookup(field);
            }
        }
        else {
            $scope.fieldHeaderName ="Add Field";
            $scope.fieldsObj.active = true;
            if(!_.isEmpty(highlightedField)) {
                $scope.fieldsObj.displayOrder = parseInt(highlightedField.display_order) + 1;
            }
            else if ($scope.formFieldsObj[group.id] && $scope.formFieldsObj[group.id].length) {
                $scope.fieldsObj.displayOrder = Math.max.apply(Math, $scope.formFieldsObj[group.id].map(function(o) {
                    return parseInt(o.display_order);
                })) + 5;
            }
            else {
                $scope.fieldsObj.displayOrder = 0;
            }
        }
    };

    /*
    * Handle save and edit Form list fields
    */
    $scope.addField = function (formObj, fieldsForm) {
        if (!fieldsForm.$valid) {
            $ioAlert.show('', 'Please fill the required fields', 'error');
            return
        }

        if (!formObj.fieldName.match(/^[a-zA-Z0-9_]+$/)) {
            $ioAlert.show('Error', 'Field Name allows Alpha Numeric Characters and Underscores ( _ ) only', 'error');
            return
        }

        if(formObj.fieldName.length > FIELD_MAX_LENGTH) {
            const message = 'Field Name length should be less than ' + FIELD_MAX_LENGTH + ' characters';
            $ioAlert.show('Error', message, 'error');
            return
        }

        if ((formObj.inputType === 'calculated' || formObj.inputType === 'calculated-override') && !formObj.formula) {
            $ioAlert.show('Error', `A ${formObj.inputType} field must have a formula`);
            return
        }

        let group = $scope.currentGroup;
        let params = JSON.parse(JSON.stringify(formObj));
        params.formId = formId;
        params.clusterId = ClusterService.clusterIds[0];
        if (params.required == true) {
            params.required = 'yes'
        } else {
            params.required = 'no'
        }
        if (params.clearOnClone == true) {
            params.clearOnClone = 'yes'
        } else {
            params.clearOnClone = 'no'
        }
        if (params.gridShow == true) {
            params.gridShow = 'yes'
        } else {
            params.gridShow = 'no'
        }
        if (params.active == true) {
            params.active = 'yes'
        } else {
            params.active = 'no'
        }
        if (params.dashboardEnabled == true) {
            params.dashboardEnabled = "yes"
        } else {
            params.dashboardEnabled = "no"
        }
        if (params.hasDateRules == true) {
            params.hasDateRules = 1
        } else {
            params.hasDateRules = 0
        }
        if (params.showLongText == true) {
            params.showLongText = 1
        } else {
            params.showLongText = 0
        }
        if (params.dataType == 'date' && params.defaultValue) {
            const defaultValue = {
                dateOption: params.defaultValue,
                numDays: params.numDays,
                businessDay: params.businessDay,
            };
            params.defaultValue = JSON.stringify(defaultValue);
        } else if (params.inputType == 'multiselect' || params.inputType == 'multiselect-custom') {
            if (params.defaultValue && angular.isArray(params.defaultValue)) {
                params.defaultValue = JSON.stringify(params.defaultValue)
            } else {
                params.defaultValue = JSON.stringify([]);
            }
        } else if(params.defaultValue && !angular.isString(params.defaultValue)){
            params.defaultValue = JSON.stringify(params.defaultValue);
        }

        if ($scope.isNew) {
            if (params.hasDateRules) {
                params.updateDateRule = "yes";
                _.each($scope.fieldsList, function (fieldObj) {
                    if (fieldObj.field_name == 'start_date' || fieldObj.field_name == 'end_date') {
                        if (fieldObj.date_rules) {
                            params.dateRules = fieldObj.date_rules
                        }
                    }
                })
            }
            FormService.saveFormFields(params).then(function (data) {
                if (data) {
                    if (!$scope.formFieldsObj[group.id]) {
                        $scope.formFieldsObj[group.id] = []
                    }
                    $scope.fieldsList.push(data);
                    filterGroupFormListFields(data.group_id);
                    getFormFields();
                    $scope.showForm = false;
                    $scope.modalShown = false;
                    $ioAlert.show('', 'Field Added successfully', 'success');
                    formFieldsHelper();
                }
            }, function (error) {
                console.log("error saving form field");
                $ioAlert.show('Error!', error, 'error')
            })
        } else {
            if (params.groupId && (params.groupId != group.id)) {
                params.displayOrder = FormService.computeHighestDisplayOrderInGroup($scope.fieldsList, params.groupId);
            }
            FormService.updateFormFields(params).then(function (formField) {
                if (formField) {
                    processUpdateFormFieldsSuccess(group, formField);
                }
                $scope.showForm = false;
                $scope.modalShown = false;
                $ioAlert.show('', 'Field updated successfully', 'success');
            }, function (data) {
                if (data.requires_deletion) {
                    // Get user confirmation, they try to update the field again.
                    const message = data.message;
                    const numAffectedFields = data.num_affected_fields;
                    let modalForceObj = $modal.open(
                        ModalService.returnModalType('forceAddOrUpdateFormField', {
                            data: {
                                message: message,
                                numAffectedFields: numAffectedFields,
                            }
                        })
                    );
                    modalForceObj.result.then(function() {
                        // Note that we could support data.conversion_possible one day.
                        params.__FORCE_DELETE_EXISTING_VALUES__ = 1;
                        FormService.updateFormFields(params).then(function (formField) {
                            if (formField) {
                                processUpdateFormFieldsSuccess(group, formField);
                            }
                            $scope.showForm = false;
                            $scope.modalShown = false;
                            $ioAlert.show('', 'Field updated successfully', 'success');
                        }, function (data) {
                            console.log("Error updating form field: " + data.errors);
                            $ioAlert.show('Error!', data.errors, 'error')
                        });
                    }, function(cancel) {
                        $scope.showForm = false;
                        $scope.modalShown = false;
                        $ioAlert.show('', 'Update operation cancelled', 'warn');                        }
                    );
                } else {
                    console.log("Error updating form field: " + data.errors);
                    $ioAlert.show('Error!', data.errors, 'error')
                }
            });
        }
    };

    const processUpdateFormFieldsSuccess = function(group, formField) {
        let formFieldIndex = _.findIndex($scope.fieldsList, {id: formField.id});
        if (formFieldIndex>=0) {
            $scope.fieldsList[formFieldIndex] = formField
        }
        filterGroupFormListFields(formField.group_id);
        formFieldsHelper();
        if (formField.group_id != group.id) {
            filterGroupFormListFields(group.id) // If it was moved to another group, filter the old group too
            // And if it was moved, we need to recompute both groups' can_be_deleted attribute to correctly
            // display the trash can icon that allows deleting the group. Note that this icon is not implemented
            // in formListGroup.html yet (it is only available for products and flights), but in case it ever
            // gets done, then the attribute will be set correctly.
            group.can_be_deleted = FormService.groupCanBeDeleted(group.id, $scope.fieldsList);
            let newGroup = _.find($scope.groupsList, {id: formField.group_id});
            if (newGroup) {
                newGroup.can_be_deleted = FormService.groupCanBeDeleted(formField.group_id, $scope.fieldsList);
            }
        }
    };

        //  Get lookup content for selected input type
        $scope.getLookupContent = function (resetDefaultVal = false) {
            if ($scope.fieldsObj.inputType == 'checkbox') {
                $scope.defaultLookupContents = [
                    {name:'Yes', value: 1},
                    {name:'No', value: 0},
                    {name:'', value: undefined},
                ];
                return;
            }
            if ($scope.fieldsObj.lookupTypeId) {
                if (resetDefaultVal && ($scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom')) {
                    $scope.fieldsObj.defaultValue = [];
                }
                FormService.getLookupContent($scope.fieldsObj.lookupTypeId, ClusterService.clusterIds[0]).then(function () {
                    $scope.defaultLookupContents = FormService.lookupContent;
                    $scope.defaultLookupContents.forEach(lookupContent => {
                        if (lookupContent.parent_name && lookupContent.parent_name.length > 0) {
                            lookupContent.lookup_value = lookupContent.lookup_value + 
                            ' <- ' + lookupContent.parent_name;
                        }
                    });
                }, function () {
                    console.log("error loading lookup contents for lookup type Id: ");
                });
            }
        }
        /*
        *    Handle formatting the Form list fields object
        */
        var formatObj = function(obj, is_copy = false) {
            var keys = Object.keys(obj);
            let prev_field_id = $scope.fieldsObj.id;

            for (var i = 0, len = keys.length; i < len; i++) {
                switch (keys[i]) {
                    case 'id':
                        $scope.fieldsObj.id = obj[keys[i]];
                        break;
                    case 'data_type':
                        $scope.fieldsObj.dataType = obj[keys[i]];
                        break;
                    case 'field_name':
                        if (is_copy){
                            $scope.fieldsObj.fieldName = obj[keys[i]] + "_copy";
                        } else {
                            $scope.fieldsObj.fieldName = obj[keys[i]];
                        }
                        break;
                    case 'display_name':
                        if (is_copy) {
                            $scope.fieldsObj.displayName = obj[keys[i]] + " (Copy)";
                        } else {
                            $scope.fieldsObj.displayName = obj[keys[i]];
                        }
                        break;
                    case 'input_type':
                        $scope.fieldsObj.inputType = obj[keys[i]];
                        break;
                    case 'is_editable':
                        $scope.fieldsObj.isEditable = (obj[keys[i]])?obj[keys[i]]:'enable';
                        break;
                    case 'parent_id':
                        $scope.fieldsObj.parentId = obj[keys[i]];
                        break;
                    case 'parent_trigger_id':
                        $scope.fieldsObj.parentTriggerId = obj[keys[i]];
                        break;
                    case 'lookup_type_id':
                        $scope.fieldsObj.lookupTypeId = obj[keys[i]];
                        break;
                    case 'required':
                        $scope.fieldsObj.required = (obj[keys[i]] == 1);
                        break;
                    case 'clear_on_clone':
                        $scope.fieldsObj.clearOnClone = (obj[keys[i]] == 1);
                        break;
                    case 'show_long_text':
                        $scope.fieldsObj.showLongText = obj[keys[i]] == 1 ? true : false;
                        break;
                    case 'enable_type_ahead':
                        $scope.fieldsObj.enableTypeAhead = obj[keys[i]] == 1 ? true : false;
                        break;
                    case 'cascading_field_name':
                        $scope.fieldsObj.cascadingFieldName = obj[keys[i]];
                        break;
                    case 'display_order':
                        if (is_copy) {
                            $scope.fieldsObj.displayOrder = parseInt(obj[keys[i]]) + 1;
                        } else {
                            $scope.fieldsObj.displayOrder = parseInt(obj[keys[i]]);
                        }
                        break;
                    case 'grid_show':
                        $scope.fieldsObj.gridShow = (obj[keys[i]] == 1);
                        break;
                    case 'dashboard_enabled':
                        $scope.fieldsObj.dashboardEnabled = (obj[keys[i]] == 1);
                        break;
                    case 'active':
                        $scope.fieldsObj.active = (obj[keys[i]] == 1);
                        break;
                    case 'help_text':
                        $scope.fieldsObj.helpText = obj[keys[i]];
                        break;
                    case 'formula':
                        $scope.fieldsObj.formula = obj[keys[i]];
                        break;
                    case 'validation_rules':
                        $scope.fieldsObj.validationRules = obj[keys[i]];
                        break;
                    case 'goal_association':
                        $scope.fieldsObj.goalAssociation = obj[keys[i]];
                        break;
                    case 'rollup_field_name':
                        $scope.fieldsObj.rollupFieldName = obj[keys[i]];
                        break;
                    case 'custom_edit_action_id':
                        $scope.fieldsObj.customEditAction = obj[keys[i]];
                        break;
                    case 'notes':
                        $scope.fieldsObj.notes = obj[keys[i]];
                        break;
                    case 'default_value':
                        let defaultValue = obj[keys[i]];
                        $scope.fieldsObj.defaultValue = defaultValue;
                        if(obj.data_type === "time" && defaultValue){
                            if(defaultValue.indexOf(":")>0 && (defaultValue.indexOf(" AM")>0 || defaultValue.indexOf(" PM")>0)) {
                                let timeData = defaultValue.split(" ");
                                const ampm = timeData[1];
                                timeData = timeData[0].split(":");
                                timeData[0] = (ampm === "PM") ? (parseInt(timeData[0]) + 12) : parseInt(timeData[0]);
                                timeData[0] = (parseInt(timeData[0]) < 10) ? "0" + parseInt(timeData[0]) : parseInt(timeData[0]);
                                timeData[1] = (parseInt(timeData[1]) < 10) ? "0" + parseInt(timeData[1]) : parseInt(timeData[1]);
                                $scope.fieldsObj.timeEditor = timeData[0] + ":" + timeData[1]+":00";
                            }
                        } else if (obj.data_type === 'date' && defaultValue) {
                            let params = '';
                            try {
                                params = JSON.parse(defaultValue);
                            } catch (e) {
                                params = 'string'
                            }
                            if ((typeof params) == 'object') {
                                $scope.fieldsObj.defaultValue = params.dateOption;
                                $scope.fieldsObj.numDays = params.numDays;
                                const offset = parseInt(params.numDays);
                                $scope.dateOffset = isNaN(offset) ? 0 : offset;
                                $scope.fieldsObj.businessDay = params.businessDay;
                            }
                        }
                        break;
                    case 'has_date_rules':
                        $scope.fieldsObj.hasDateRules = obj[keys[i]] == '1' ? true : false;
                        break;
                }
            }
            if(prev_field_id != $scope.fieldsObj.id) {
                $scope.defaultValuePrevType = "";
            }
            $scope.checkType();
        };

        /*
        *  Handle properties of selected input types
        */
        $scope.checkType = function () {
            switch ($scope.fieldsObj.inputType) {
                case 'creative':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "file";
                    break;
                case 'geo-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'geo-targeting-google':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'location-picker':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'location-picker-fb':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'location-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ads-aud-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'DFP':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'day-parting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'age-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snap-chat-age-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'ad-group':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-create-ads':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'dfp-frequency':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'devices':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'device-capability':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'dfp_ad_units':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'connection':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'mobile-app':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'service-mapper':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.fieldName = "serviceMapper";
                    $scope.isFieldNameDisable = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'multiple-mappings':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'checkbox':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "tinyint";
                    break;
                case 'currency':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "currency";
                    break;
                case 'percentage':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "percentage";
                    break;
                case 'file':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "file";
                    break;
                case 'custom_file':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "file";
                    break;
                case 'emoji':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'select':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'multiselect':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'multiselect-custom':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'timeselect':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "time";
                    break;
                case 'ad-schedule':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'metric-select':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'content-links':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'shopping_adgroup_singleproduct':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'shopping_adgroup_multiproduct':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-ads-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snapchat-ads-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebookAds-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snapChat-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'xandrInvest-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'xandr-invest-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterestAds-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ads-bidding':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-audiences':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snap-gender':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'advanced-demographics':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snap-predefined-audiences':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterest-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tritonAds-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tritonAds-teams-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'yelpAds-categories':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'custom-macro-mapping':
                case 'custom-macro-mapping-2':
                case 'seed-list-macros':
                case 'pos-matchback-details':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ads-extension':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'linkedin-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tiktok-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tiktok-device-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'bridge-email-test':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'image-upload':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ad-manager-avail-units':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterest-geo-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'triton-listener-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'links-and-main-cta':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'final-approval':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterest-keyword':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'linkedin-campaign-objective':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-page-id':
                case 'triton-geo-targeting':
                case 'linkedin-geo-targeting':
                case 'triton-creative-management':
                case 'triton-time-targeting':
                case 'triton-content-targeting':
                case 'snapchat-pixel-controls':
                case 'accountability-group-label':
                case 'tiktok-geo-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'readonly':
                case 'textarea':
                case 'textplain-area':
                    // to avoid using hyperlink
                    $scope.fieldsObj.dataType = "string";
                    // do not need break here, we will continue using default
                default:
                    $scope.isFieldNameDisable = false;
                    $scope.isDisabled = false;
            }
            if ($scope.fieldsObj.inputType == 'select' ||
                $scope.fieldsObj.inputType == 'multiselect' ||
                $scope.fieldsObj.inputType == 'multiselect-custom' ||
                $scope.fieldsObj.inputType == 'checkbox'
            ) {
                $scope.getLookupContent();
            }
            if($scope.fieldsObj.inputType == 'select' && !angular.isString($scope.fieldsObj.defaultValue)){
                $scope.fieldsObj.defaultValue = null;
            }
            if (FormService.inputTypesNoLookupType().includes($scope.fieldsObj.inputType)) {
                $scope.showLookupType = false;
                $scope.fieldsObj.lookupTypeId = null;
            } else {
                $scope.showLookupType = true;
            }
            $scope.checkDataType();
        };

        /*
        *   Handle goal association type
        */
        $scope.changeGoalAssociationType = function() {
            switch($scope.fieldsObj.goalAssociation) {
                case 'name':
                case 'campaign_name':
                case 'column':
                case 'service_id':
                case 'smart_campaign_id':
                    $scope.fieldsObj.dataType = 'string'
                    $scope.isDisabled = true;
                    break;
                case 'target':
                    $scope.fieldsObj.dataType = 'decimal';
                    $scope.isDisabled = true;
                    break;
                case 'start':
                case 'end':
                    $scope.fieldsObj.dataType = 'date';
                    $scope.isDisabled = true;
                    break;
                case 'customer_id':
                    $scope.fieldsObj.dataType = 'integer';
                    $scope.isDisabled = true;
                    break;
                case 'threshold_1':
                case 'threshold_2':
                    $scope.fieldsObj.dataType = 'tinyint';
                    $scope.isDisabled = true;
                    break;
            }
        }

        /*
        *  Handle checking the datatype and assigning related properties
        */
        $scope.checkDataType = function () {
            switch ($scope.fieldsObj.dataType) {
                case 'currency':
                case 'percentage':
                case 'decimal':
                case 'integer':
                case 'tinyint':
                    $scope.fieldsObj.defaultValue = parseFloat($scope.fieldsObj.defaultValue);
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'number';
                    $scope.defaultInputType = 'text';
                    break;
                case 'date':
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'date';
                    $scope.defaultInputType = 'date';
                    break;
                case 'time':
                    if ($scope.fieldsObj.defaultValue && typeof $scope.fieldsObj.defaultValue == "string") {
                        var dateVal = String($scope.fieldsObj.defaultValue);
                        if (dateVal.indexOf("T") >= 0) {
                            var dateObj = new Date(dateVal);
                        } else {
                            dateVal = dateVal.split(":");
                            var dateObj = new Date(0, 0, 0, parseInt(dateVal[0]), parseInt(dateVal[1]), 0);
                        }
                        $scope.fieldsObj.timeEditor = dateObj;
                    }
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'time';
                    $scope.defaultInputType = 'time';
                    break;
                case 'hyperlink':
                    $scope.fieldsObj.dataType = [
                        'text',
                        'calculated',
                        'calculated-override'
                    ].includes($scope.fieldsObj.inputType) ?
                        'hyperlink' : 'string';
                    // Do not need break here, we will continue using 'string'
                case 'string':
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'text';
                    $scope.defaultInputType = 'text';
                    break;
                default:
                    $scope.defaultValueDisabled = true;
                    $scope.defaultValueType = 'text';
                    $scope.defaultInputType = 'text';
            }
            if (!['currency','decimal','integer','percentage'].includes($scope.fieldsObj.dataType)) {
                // Clear the rollup field name if the data type is incompatible with rolling up.
                $scope.fieldsObj.rollupFieldName = undefined;
            }
            if ($scope.defaultValuePrevType != "" && ($scope.defaultValuePrevType != $scope.defaultValueType || $scope.defaultValueDisabled === true)) {
                $scope.fieldsObj.defaultValue = '';
            }
            if ($scope.fieldsObj.inputType == 'select' || $scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom') {
                $scope.defaultInputType = $scope.fieldsObj.inputType;
                if (($scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom') && $scope.fieldsObj.defaultValue && !angular.isArray($scope.fieldsObj.defaultValue)) {
                    $scope.fieldsObj.defaultValue = JSON.parse($scope.fieldsObj.defaultValue);
                }
            } else if ($scope.fieldsObj.inputType == 'checkbox') {
                $scope.defaultInputType = 'checkbox';
            }
            $scope.defaultValuePrevType = $scope.defaultValueType;
        }

    /*
     * Check for lookup content based on the parent id
     *    Handle checking lookup contents
    */
        $scope.checkLookup = function (field) {
            var element = _.find($scope.fieldsList, function (field) {
                return $scope.fieldsObj.parentId == field.id;
            });
            $scope.showParentMultiSelect = (element && element.input_type == "checkbox")?false:true;
            if (element && element.lookup_type_id) {
                FormService.getLookupContent(element.lookup_type_id).then(function () {
                    $scope.lookupContents = _.orderBy(FormService.lookupContent, 'lookup_value');
                    $scope.lookupContents.forEach(lookupContent => {
                        if (lookupContent.parent_name && lookupContent.parent_name.length > 0) {
                            lookupContent.lookup_value = lookupContent.lookup_value + 
                            ' <- ' + lookupContent.parent_name;
                        }
                    });
                }, function () {
                    console.log("error loading lookup contents for lookup type Id: " + $scope.lookupId);
                });
            } else if (element && element.input_type == "checkbox") {
                $scope.lookupContents = [{
                    "id": "0",
                    "lookup_value": "No"
                }, {
                    "id": "1",
                    "lookup_value": "Yes"
                }];
            }
        };


        $scope.cancelModal = function () {
            $scope.showForm = false;
            $scope.modalShown = false;
            // $modalInstance.dismiss();
        };


    function showGroupModal(type, data) {
        data.orderTypes = $scope.orderTypes;
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    $scope.plusDateOption = function() {
        if ($scope.fieldsObj.defaultValue == undefined ||
            $scope.fieldsObj.defaultValue == '') {
            $scope.fieldsObj.defaultValue = 'Today';
        }
        $scope.dateOffset++;
        const operator = $scope.dateOffset > 0 ? '+':'';
        const offset = $scope.dateOffset == 0 ? '' : $scope.dateOffset;
        $scope.fieldsObj.numDays = operator + offset;
    }

    $scope.minusDateOption = function() {
        if ($scope.fieldsObj.defaultValue == undefined ||
            $scope.fieldsObj.defaultValue == '') {
            $scope.fieldsObj.defaultValue = 'Today';
        }
        $scope.dateOffset--;
        const operator = $scope.dateOffset > 0 ? '+':'';
        const offset = $scope.dateOffset == 0 ? '' : $scope.dateOffset;
        $scope.fieldsObj.numDays = operator + offset;
    }

    $scope.inputNumDays = function() {
        const offset = parseInt($scope.fieldsObj.numDays);
        $scope.dateOffset = isNaN(offset) ? 0 : offset;
    }

    $scope.clearDateOption = function() {
        $scope.fieldsObj.defaultValue = undefined;
        $scope.fieldsObj.numDays = undefined;
        $scope.dateOffset = 0;
    }

    $scope.$watch('fieldsObj.timeEditor', function() {
        if ($scope.fieldsObj?.timeEditor) {
            $scope.fieldsObj.defaultValue =
                String($filter('date')($scope.fieldsObj.timeEditor, "HH:mm")) + ":00";
        }
    });
    
    $scope.addGroup = function(group) {
        var formObj = {};
        formObj.groupName = "GROUP";
        formObj.active = 1;
        formObj.formId = formId;
        formObj.clusterId = ClusterService.clusterIds[0];
        if ( $scope.groupsList &&  $scope.groupsList.length) {
            formObj.groupDisplayOrder = Math.max.apply(Math,  $scope.groupsList.map(function(o) {
                return parseInt(o.group_display_order);
            })) + 1;
        } else {
            formObj.groupDisplayOrder = 1;
        }
        FormService.saveFormFieldGroups(formObj).then(function(data) {
            if (data?.id) {
                data.active = data.active == '1';
                $scope.groupsList.push(data);
                parseHideCondition();
                updateDisplayGroupsList();
                $scope.isExpandCollapseButtonDisabled = false;
                $ioAlert.show('', 'Group Added successfully', 'success');
            }
        }, function(error) {
            console.log(error);
            $ioAlert.show('Error!', JSON.stringify(error), 'error');
        });
    };

    $scope.changeDisplayOrder = function(group, list) {
        var params = {
            cascadingFieldName: list.cascading_field_name,
            dataType: list.data_type,
            displayName: list.display_name,
            displayOrder: list.display_order,
            fieldName: list.field_name,
            formula: list.formula,
            groupId: list.group_id,
            helpText: list.help_text,
            id: list.id,
            inputType: list.input_type,
            lookupTypeId: list.lookup_type_id,
            parentId: list.parent_id,
            parentTriggerId: list.parent_trigger_id,
            validationRules: list.validation_rules,
            goalAssociation: list.goal_association,
            rollupFieldName: list.rollup_field_name,
            customEditAction: list.custom_edit_action_id,
            formId:list.form_id
        }
        if (list.required == true) {
            params.required = 1;
        } else {
            params.required = 0;
        }
        if (list.gridShow == true) {
            params.gridShow = 1;
        } else {
            params.gridShow = 0;
        }
        if (list.active == true) {
            params.active = "yes";
        } else {
            params.active = "no";
        }

        FormService.updateFormFields(params).then(function(data) {
            if (data) {
                for (var i = 0, len = $scope.formFieldsObj[group.id].length; i < len; i++) {
                    if (data.id == $scope.formFieldsObj[group.id][i].id) {
                        data.display_order = parseInt(data.display_order);
                        $scope.formFieldsObj[group.id][i] = data;
                        $ioAlert.show('', 'Display Order updated successfully', 'success');
                        list.changeOrder = false;
                        break;
                    }
                }
            }
        }, function() {
            $ioAlert.show('Error', 'Error updating Display Order', 'error');
        });
    }

    $scope.updateHideCondition = function (group){
        showGroupModal('updateHideConditionForm', {
            group: group,
            hideConditionTypes: $scope.hideConditionTypes,
            roleTypes: $scope.roleTypes,
            orderTypes: $scope.orderTypes,
        }).result.then(function(formObj) {
            if (formObj.hideForCondition?.length > 0) {
                group.hide_for_condition = {
                    "type": formObj.hideForConditionType,
                    "id": formObj.hideForCondition.toString(),
                };
            } else {
                group.hide_for_condition = undefined;
            }
            group.hide_for_condition = JSON.stringify(group.hide_for_condition);
            let param = {};
            param.groupName = group.group_name;
            param.groupDisplayOrder = group.group_display_order;
            param.id = group.id;
            param.contentTypeId = group.content_type_id;
            param.formId = group.form_id;
            param.active = (group.active === true || group.active == '1') ? '1' : '0';
            param.hideForCondition = group.hide_for_condition;
            FormService.updateFormFieldGroups(param).then(function(data) {
                if (data.errors) {
                    groupObj.active = (groupObj.active == true) ? false : true;
                    $ioAlert.show('', data.errors[0], 'error');
                } else {
                    if (data && data.formFieldGroup && data.formFieldGroup.id) {
                        data.formFieldGroup.active = data.formFieldGroup.active == '1' ? true : false;
                        for (var i = 0, len = $scope.groupsList.length; i < len; i++) {
                            if ($scope.groupsList[i].id == data.formFieldGroup.id) {
                                $scope.groupsList[i] = data.formFieldGroup;
                                break;
                            }
                        }
                        parseHideCondition();
                        updateDisplayGroupsList();
                        $ioAlert.show('', 'Updated Successfully', 'success');
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function(error) {
            console.log("modal dismissed");
        })

    };

    $scope.cloneForm = function() {

        var modalObj = $modal.open(
            ModalService.returnModalType('cloneFormGroup', {
                data: {
                    formId: formId
                }
            })
        );

        modalObj.result.then(function(formObj) {
            FormService.cloneForm(formId, formObj.name).then(function(data) {
                if (FormService.formId) {
                    $ioAlert.show('', 'New form ' + formObj.name + ' created successfully', 'success');
                } else {
                    $ioAlert.show('', 'An error occurred cloning form.', 'error');
                }
            }, function(error) {
                $ioAlert.show('', 'An error occurred cloning form.', 'error');
            });

        }, function(cancel) {});
    };

    /*
     * Handle add date rule
     */
    $scope.showDateRules = function() {
        if (haveStartEndDates()) {
            $modal.open({
                controller: 'FormDateRuleController',
                templateUrl: dateRulesHtmlUrl,
                resolve: {
                    fieldsList: function() {
                        return $scope.fieldsList;
                    }
                },
                backdrop: 'static'
            }).result.then(function(dateRulesObj) {
                _.each($scope.fieldsList, function(fieldObj) {
                    if (fieldObj.field_name == 'start_date') {
                        updateFormFieldDateRule(fieldObj, dateRulesObj.startDate);
                    } else if (fieldObj.field_name == 'end_date') {
                        updateFormFieldDateRule(fieldObj, dateRulesObj.endDate);
                    }
                });
            }, function(cancel) {
                console.info("cancelled task modal");
            });
        } else {
            $ioAlert.show('Error!', 'You must add "start_date" and "end_date" fields before configuring date rules', 'error');
        }
    }

    var haveStartEndDates = function() {
        var hasStartDate = false;
        var hasEndDate = false;
        _.each($scope.fieldsList, function(fieldObj) {
            if (fieldObj.field_name == 'start_date') {
                hasStartDate = true;
            } else if (fieldObj.field_name == 'end_date') {
                hasEndDate = true;
            }
        });
        return (hasStartDate && hasEndDate);
    }

    var updateFormFieldDateRule = function(fieldObj, dateRuleObj) {
        var params = {};
        params.id = fieldObj.id;
        params.active = (fieldObj.active == "1") ? 'yes' : 'no';
        params.cascadingFieldName = fieldObj.cascading_field_name;
        params.contentTypeId = fieldObj.content_type_id;
        params.dashboardEnabled = (fieldObj.dashboard_enabled == "1") ? 'yes' : 'no';
        params.dataType = fieldObj.data_type;
        params.dateRules = dateRuleObj.numDays ? JSON.stringify(dateRuleObj) : '';
        params.defaultValue = fieldObj.default_value;
        params.displayName = fieldObj.display_name;
        params.displayOrder = fieldObj.display_order;
        params.fieldName = fieldObj.field_name;
        params.formula = fieldObj.formula;
        params.gridShow = (fieldObj.grid_show == "1") ? 'yes' : 'no';
        params.groupId = fieldObj.group_id;
        params.hasDateRules = dateRuleObj.numDays ? 1 : 0;
        params.helpText = fieldObj.help_text;
        params.inputType = fieldObj.input_type;
        params.lookupTypeId = fieldObj.lookup_type_id;
        params.parentId = fieldObj.parent_id;
        params.parentTriggerId = fieldObj.parent_trigger_id;
        params.formId = fieldObj.form_id;
        params.required = (fieldObj.required == "1") ? "yes" : "no";
        params.showLongText = (fieldObj.show_long_text == "1") ? 0 : 0;
        params.enableTypeAhead = (fieldObj.enable_type_ahead == "1") ? 1 : 0;
        params.validationRules = fieldObj.validation_rules;
        params.goalAssociation = fieldObj.goal_association;
        params.rollupFieldName = fieldObj.rollup_field_name;
        params.customEditAction = fieldObj.custom_edit_action_id;
        params.updateDateRule = 'yes';

        FormService.updateFormFields(params).then(function(data) {
            if (data) {
                var fieldIndex = _.findIndex($scope.fieldsList, { id: data.id });
                if (fieldIndex) {
                    $scope.fieldsList[fieldIndex] = data;
                }
                if (data.field_name == "end_date") {
                    $ioAlert.show('Success', 'Date Rules updated successfully', 'success');
                }
            }
        }, function() {
            console.log("error updating form field");
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'singleSelect');
        DateRangeService.init();
        getDataTypes();
        getInputTypes();
        getGoalAssociationTypes();
        getRollupFieldNames(); // Loaded asynchronously
        getWorkflowActions();
        getLookupTypes();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

FormListLookupController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', 'FormService', 'ProductService', 'ClusterService', 'DateRangeService', 'UserService', '$modal', '$ioAlert', 'ModalService'];

function FormListLookupController($scope, $rs, $stateParams, $state, FormService, ProductService, ClusterService, DateRangeService, UserService, $modal, $ioAlert, ModalService) {
    $scope.formId = $stateParams.formId;
    $scope.contentTypeId = $stateParams.contentTypeId;
    $scope.formContents = [];
    $scope.lookupContentObj = {};
    $scope.formContentsList = {};
    $scope.firstTime = true;
    $scope.disableBtnAction = false;

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        if ($scope.firstTime) {
            getFormContents();
            $scope.firstTime = false;
        }
        else {
            // If the Business Unit is changed, we don't know for sure which form to use, since it could be for All
            // Business Units, and several order workflows can exist then.  So just go back to the main formList page.
            $scope.backToList();
        }

    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    var getFormContents = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Lookup Contents";
        FormService.getTypesForForm($scope.formId).then(function(data) {
            $scope.formContents = data;
            $rs.loadingInProgress = false;
        }, function(data) {
            console.log("error loading form contents list");
            $rs.loadingInProgress = false;
        });
    };

    $scope.toggle = function(ev, lookup) {
        $(ev.target).siblings(':last').slideToggle(200);
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');

            $scope.lookupContentObj[lookup.id] = [];
            $scope.formContentsList[lookup.id] = [];

            ProductService.getLookupContent(lookup.id, ClusterService.clusterIds[0]).then(function(success) {
                $scope.lookupContentObj[lookup.id] = ProductService.lookupContents;
            }, function(error) {
                console.log("error loading lookup contents");
            });

            FormService.getFormContents($scope.formId, lookup.id, ClusterService.clusterIds[0]).then(function(data) {
                $scope.formContentsList[lookup.id] = data;
            }, function(data) {
                console.log("error loading form contents list");
            });
        } else {
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
        }
    };

    function showAddModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    $scope.addFormLookupContent = function(lookupId, formContent) {
        var isNew = true;
        if (formContent) {
            isNew = false;
        }
        showAddModal('addFormLookupContent', {
            formId: $scope.formId,
            lookupAttributes: $scope.lookupContentObj[lookupId],
            formContent: formContent
        }).result.then(function(formObj) {
            var param = {};
            param.formId = formObj.formId;
            param.lookupTypeId = lookupId;
            param.clusterId = ClusterService.clusterIds[0];

            if (!isNew && !formObj.lookupContents) {
                param.lookupTypeId = lookupId;

                FormService.deleteFormContents(param).then(function(data) {
                    $scope.formContentsList[lookupId] = [];
                    $ioAlert.show('', 'Form lookup content deleted successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                param.lookupContents = [];

                if (formObj.lookupContents) {
                    for (var i = 0; i < formObj.lookupContents.length; i++) {
                        param.lookupContents.push(formObj.lookupContents[i].id);
                    }
                }

                if (isNew && param.lookupContents.length) {
                    FormService.addFormContents(param).then(function(data) {
                        if (data.errors) {
                            $ioAlert.show(data.errors);
                        } else {
                            $scope.formContentsList[lookupId] = [];
                            for (var i = 0, len = data.formLookupContents.length; i < len; i++) {
                                $scope.formContentsList[lookupId].push({
                                    "form_lookup_content_id": data.formLookupContents[i].id,
                                    "id": data.formLookupContents[i].lookup_content_id
                                })
                            }
                            $ioAlert.show('', 'Form lookup content added successfully', 'success');
                        }

                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else if (!isNew) {
                    FormService.updateFormContents(param).then(function(data) {
                        if (data.errors) {
                            $ioAlert.show(data.errors);
                        } else {
                            $scope.formContentsList[lookupId] = [];
                            for (var i = 0, len = data.formLookupContents.length; i < len; i++) {
                                $scope.formContentsList[lookupId].push({
                                    "form_lookup_content_id": data.formLookupContents[i].id,
                                    "id": data.formLookupContents[i].lookup_content_id
                                })
                            }
                            $ioAlert.show('', 'Form lookup content updated successfully', 'success');
                        }

                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
            }
        }, function(cance) {
            console.log("cancel")
        })
    };

    $scope.backToList = function() {
        $state.go('formList');
    };

    function openCloneModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    var getTaskForms = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Task Form List";
        FormService.getAllTaskForms().then(function(data) {
            $scope.formList = data;
            $rs.loadingInProgress = false;
            doCloneLookupContent();
        }, function(data) {
            console.log("error loading task form list");
            $rs.loadingInProgress = false;
        });
    };

    var getOrderForms = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Order Form List";
        FormService.getAllOrderForms().then(function(data) {
            $scope.formList = data;
            $rs.loadingInProgress = false;
            doCloneLookupContent();
        }, function(data) {
            console.log("error loading order form list");
            $rs.loadingInProgress = false;
        });
    };

    var getClientForms = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Client Form List";
        FormService.getAllClientForms().then(function(data) {
            $scope.formList = data;
            $rs.loadingInProgress = false;
            doCloneLookupContent();
        }, function(data) {
            console.log("error loading client form list");
            $rs.loadingInProgress = false;
        });
    };

    var doCloneLookupContent = function() {
        openCloneModal('cloneFormLookupContent', {
            clusters: ClusterService.clusters,
            formContentTypes: $scope.formContents,
            formList: $scope.formList,
            formId: $scope.formId,
        }).result.then(function(formObj) {
            var param = {
                "sourceFormId": $stateParams.formId,
                "sourceClusterId": ClusterService.clusterIds[0],
                "destClusterIds": formObj.destClusterIds,
                "lookupTypeIds": formObj.lookupTypeIds,
                "destFormIds": formObj.destFormIds,
            }
            FormService.cloneLookupContent(param).then(function(data) {
                if (data.errors) {
                    $ioAlert.show('', 'No Data Found', 'error');
                } else {
                    $ioAlert.show('', 'Lookup type cloned successfully', 'success');
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        })
    }

    $scope.cloneLookupContent = function() {
        if ($rs.loadingInProgress) return;  // Don't start this (potentially several times) if we're waiting for stuff to load...

        if (!ClusterService.clusterIds.length) {
            $ioAlert.show('', 'You must select a business unit to continue.', 'error');
        } else {
            // Only get the forms list we need according to the type of the form we are cloning content from.
            switch ($scope.contentTypeId) {
                case "1":
                    getTaskForms();
                    break;
                case "2":
                    getOrderForms();
                    break;
                case "3":
                    getClientForms();
                    break;
            }
        }
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();
    var init = function() {
        ClusterService.initCluster($rs.userRole, 'singleSelect');
        DateRangeService.init();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };
    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

FormDateRuleController.$inject = ['$scope', '$rootScope', '$modalInstance', 'fieldsList', '$ioAlert'];

function FormDateRuleController($scope, $rs, $modalInstance, fieldsList, $ioAlert) {
    var clear = function() {
        $scope.dateRulesObj = { startDate: {}, endDate: {} };

        $scope.startDaysFromLabelClass = "pull-left control-label";
        $scope.startDaysFromRequired = false;

        $scope.endDaysFromLabelClass = "pull-left control-label";
        $scope.endDaysFromRequired = false;

        $scope.businessDayClass = "pull-left control-label";

        $scope.disableEndDateBefore = false;
        $scope.disableEndDateAfter = false;
    };
    clear();
    $scope.startDateDependencies = [
        { id: "currentDate", name: "Current Date" }
    ];
    $scope.endDateDependencies = [
        { id: "currentDate", name: "Current Date" },
        { id: "orderStartDate", name: "Start Date" }
    ];

    $scope.startDateChange = function() {
        if($scope.dateRulesObj.startDate.numDays) {
            $scope.startDaysFromLabelClass = "pull-left control-label required-days-from";
            $scope.startDaysFromRequired = true;
        }else {
            $scope.startDaysFromLabelClass = "pull-left control-label";
            $scope.startDaysFromRequired = false;
        }
    };

    $scope.endDateChange = function() {
        if($scope.dateRulesObj.endDate.numDays) {
            $scope.endDaysFromLabelClass = "pull-left control-label required-days-from";
            $scope.endDaysFromRequired = true;
        }else {
            $scope.endDaysFromLabelClass = "pull-left control-label";
            $scope.endDaysFromRequired = false;
        }
    };

    $scope.endDateDependencyChange = function() {
        if ($scope.dateRulesObj.endDate.dependency == "orderStartDate") {
            $scope.disableEndDateBefore = true;
            $scope.dateRulesObj.endDate.validateOn = 'after';
        } else {
            $scope.disableEndDateBefore = false;
            $scope.disableEndDateAfter = false;
            $scope.dateRulesObj.endDate.validateOn = '';
        }
    }

    $scope.addDateRule = (dateRuleForm) => {
        if (dateRuleForm.$valid) {
            $modalInstance.close($scope.dateRulesObj);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };

    $scope.cancel = () => {
        $modalInstance.dismiss();
    };

    $scope.clearDateRule = () => {
        clear();
    };

    var init = function() {
        _.each(fieldsList, function(fieldObj) {
            if (fieldObj.field_name == 'start_date') {
                if (fieldObj.date_rules) {
                    $scope.dateRulesObj.startDate = JSON.parse(fieldObj.date_rules);
                }
            } else if (fieldObj.field_name == 'end_date') {
                if (fieldObj.date_rules) {
                    $scope.dateRulesObj.endDate = JSON.parse(fieldObj.date_rules);
                }
            }
        });
    };

    init();
}
